<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>

		<v-card-title>
			<h2>Lata realizacji projektów</h2>
			<v-spacer></v-spacer>
		</v-card-title>

		<br/>

		<v-dialog v-model="dialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mb-2">Dodaj rok</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline"> Dodaj nowy rok </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-text-field
									browser-autocomplete="off"
									v-model="editedItem.value"
									label="Rok"
									aria-label="realization year"
									for="contest-realization-years-view-year"
									id="contest-realization-years-view-year"
									v-on:click="discardErrorMessage"></v-text-field>
							</v-flex>
							<div v-if="showErrorMessage" style="color:red;">
								Rok {{ editedItem.value }} jest niepoprawny lub został już dodany.
							</div>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="create">Dodaj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:items="items"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<td class="text-xs-left">{{ props.item.value }}</td>
				<td class="text-xs-left">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="deleteItem(props.item)" >
								<v-icon color="lightred" v-on="on">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {ContestRealizationYear} from "../../../api/generated/ContestRealizationYear";

	export default {
		name: "RealizationYearsView",

		watch: {

			dialog(val) {
				!val && this.discardErrorMessage() && (this.editedIndex = -1) && (this.editedItem = {});
			},
		},

		computed: {

			isEdited() {
				return this.editedIndex !== -1;
			},
		},

		data() {
			return {

				dialog: false,

				tableHeaders: [
					{text: "Rok", value: "year", sortable: false},
					{text: "Akcje", value: "actions", sortable: false},
				],

				items: [],

				showErrorMessage: false,

				editedItem: {},

				editedIndex: -1,
			};
		},

		methods: {

			close() {
				this.editedItem = {};
				this.dialog = false;
			},

			discardErrorMessage() {
				this.showErrorMessage = false;
			},

			sortItems(items) {
				items.sort(function (x, y) {
					return y.value - x.value;
				});
			},

			yearValidationFail(value) {
				return !Number.isInteger(parseInt(value)) ||
					parseInt(value) < 1970 ||
					value !== parseInt(value).toString() ||
					this.items.map(item => item["value"]).includes(parseInt(value));
			},

			deleteItem(item) {
				this.$confirm("Czy na pewno chcesz usunąć rok?", {
					icon: 'delete',
					title: 'Usuwanie roku realizacji projektów',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							const index = this.items.indexOf(item);
							ContestRealizationYear.delete(this, item.id, successResponse => {
									this.items.splice(index, 1);
									this.$messagesBus.$emit("success", "Rok został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć roku", errorResponse);
								});
						}
					});
			},

			create() {
				if (this.yearValidationFail(this.editedItem.value)) {
					this.showErrorMessage = true;
					return;
				}
				ContestRealizationYear.post(this, this.editedItem, successResponse => {
						this.getList();
						this.close();
						this.$messagesBus.$emit("success", "Rok został pomyślnie dodany", successResponse);
					},
					errorResponse => {
						if (errorResponse.status === "BAD_REQUEST") {
							this.showErrorMessage = true;
						}
						this.$messagesBus.$emit("error", "Nie udało się dodać roku", errorResponse);
					});
			},

			getList() {
				ContestRealizationYear.getList(this, successResponse => {
						this.sortItems(successResponse.items);
						this.items = successResponse.items;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać listy lat realizacji projektów", errorResponse);
					});
			},
		},

		mounted() {
			this.getList();
		},
	};
</script>

<style scoped>

</style>
